// @ts-strict-ignore
import React, { ComponentType } from 'react';
import { runwayColors } from '../styles/globalStyles';
import Icon, { ArrowRightOutlined, CloseCircleFilled, ArrowLeftOutlined, CheckOutlined } from '@ant-design/icons';
import Space from 'antd/lib/space';
import Popconfirm from 'antd/lib/popconfirm';
import Button from 'antd/lib/button';
import Typography from 'antd/lib/typography';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const CONFIRMATION_MESSAGE = "You haven't saved your changes.";

export const NavigationBar: React.FC<{
    title: string;
    description: string;
    icon: ComponentType<CustomIconComponentProps>;
    iconColor?: string;
    shouldAskForConfirmation?: boolean;
    isFinalStep?: boolean;
    onContinue?: () => void;
    canGoBack?: boolean;
    canContinue?: boolean;
    onGoBack?: () => void;
    onClose: () => void;
    style?: React.CSSProperties;
    isSingleStep?: boolean;
    hideCloseX?: boolean;
    hideDoneButton?: boolean;
}> = ({
    title,
    description,
    icon,
    onContinue,
    onGoBack,
    canGoBack,
    canContinue,
    onClose,
    isFinalStep,
    shouldAskForConfirmation,
    style,
    isSingleStep,
    hideCloseX,
    hideDoneButton,
}) => {
    return (
        <div
            style={{
                backgroundColor: runwayColors.primary,
                minHeight: 168,
                padding: '20px 30px',
                gap: 40,
                display: 'flex',
                ...style,
            }}
        >
            <Icon component={icon} style={{ color: runwayColors.white, fontSize: 68 }} />
            <Space direction="vertical" size={16}>
                <Typography.Text style={{ color: runwayColors.white, fontSize: 24, fontWeight: 600 }}>
                    {title}
                </Typography.Text>
                <Typography.Paragraph
                    style={{ color: runwayColors.white, fontSize: 16, fontWeight: 400, maxWidth: 678 }}
                >
                    {description}
                </Typography.Paragraph>
            </Space>
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: hideCloseX ? 'normal' : 'end',
                    position: 'relative',
                }}
            >
                {!hideCloseX && (
                    <Popconfirm
                        placement="bottomRight"
                        title={CONFIRMATION_MESSAGE + ' Are you sure you want to exit?'}
                        disabled={!shouldAskForConfirmation}
                        onConfirm={onClose}
                    >
                        <Button
                            type="link"
                            size="large"
                            onClick={shouldAskForConfirmation ? null : onClose}
                            icon={<CloseCircleFilled style={{ fontSize: 28 }} />}
                            style={{ color: runwayColors.white, position: 'absolute', top: -4, right: -4 }}
                        />
                    </Popconfirm>
                )}
                <Space direction="horizontal" size={16}>
                    {canGoBack && onGoBack && (
                        <Popconfirm
                            placement="topRight"
                            title={CONFIRMATION_MESSAGE + ' Are you sure you want to go back?'}
                            disabled={!shouldAskForConfirmation}
                            onConfirm={onGoBack}
                        >
                            <Button
                                ghost
                                size="large"
                                onClick={shouldAskForConfirmation ? null : onGoBack}
                                icon={<ArrowLeftOutlined />}
                                style={{ color: runwayColors.white, borderColor: runwayColors.white }}
                            >
                                Back
                            </Button>
                        </Popconfirm>
                    )}
                    {isSingleStep && !hideDoneButton ?
                        <Button
                            onClick={onClose}
                            icon={<CheckOutlined />}
                            style={{ backgroundColor: runwayColors.primary, color: 'white' }}
                        >
                            Done
                        </Button>
                    :   onContinue && (
                            <Popconfirm
                                placement="topRight"
                                title={CONFIRMATION_MESSAGE + ' Are you sure you want to continue?'}
                                disabled={!shouldAskForConfirmation}
                                onConfirm={onContinue}
                            >
                                <Button
                                    className="setup-step-button"
                                    ghost
                                    size="large"
                                    disabled={!canContinue}
                                    onClick={
                                        isFinalStep ? onClose
                                        : shouldAskForConfirmation ?
                                            null
                                        :   onContinue
                                    }
                                    icon={<ArrowRightOutlined />}
                                    style={{ color: runwayColors.white, borderColor: runwayColors.white }}
                                >
                                    {isFinalStep ? 'Finish' : 'Next'}
                                </Button>
                            </Popconfirm>
                        )
                    }
                </Space>
            </div>
        </div>
    );
};
